'use strict';

exports.__esModule = true;
var INSURANCES = exports.INSURANCES = {
  LOAD: 'INSURANCE_PROVIDERS_LOAD',
  SUCCESS: 'INSURANCE_PROVIDERS_LOAD_SUCCESS',
  FAIL: 'INSURANCE_PROVIDERS_LOAD_FAIL'
};

var ENTITY_INSURANCES = exports.ENTITY_INSURANCES = {
  LOAD: 'ENTITY_INSURANCE_PROVIDERS_LOAD',
  SUCCESS: 'ENTITY_INSURANCES_PROVIDERS_LOAD_SUCCESS',
  FAIL: 'ENTITY_INSURANCES_PROVIDERS_LOAD_FAIL'
};

var loadInsuranceProviders = exports.loadInsuranceProviders = function loadInsuranceProviders(countryId) {
  return {
    type: INSURANCES.LOAD,
    countryId: countryId
  };
};

var loadEnityInsuranceProviders = exports.loadEnityInsuranceProviders = function loadEnityInsuranceProviders(entityKey) {
  return {
    type: ENTITY_INSURANCES.LOAD,
    entityKey: entityKey
  };
};

var loadEnityInsuranceProvidersSuccess = exports.loadEnityInsuranceProvidersSuccess = function loadEnityInsuranceProvidersSuccess(payload) {
  return {
    type: ENTITY_INSURANCES.SUCCESS,
    payload: payload
  };
};

var loadEnityInsuranceProvidersFail = exports.loadEnityInsuranceProvidersFail = function loadEnityInsuranceProvidersFail() {
  return {
    type: ENTITY_INSURANCES.FAIL
  };
};